import {
    Button,
    CircularProgress,
    downloadFile,
    SingleFileUpload,
} from "shared";
import { roleService } from "entities/role";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useRoleMatrixTranslations } from "../../lib/i18n";
import styles from "./role_matrix.module.scss";

interface IRoleMatrixProps {
}

export const RoleMatrix: React.FC<IRoleMatrixProps> = React.memo(({}) => {
    const t = useRoleMatrixTranslations();
    const [roleTreeLoading, setRoleTreeLoading] = useState(false);
    const [roleMatrixLoading, setRoleMatrixLoading] = useState(false);
    const [roleMatrixUploading, setRoleMatrixUploading] = useState(false);
    const [roleTreeUploading, setRoleTreeUploading] = useState(false);

    const onDownloadRoleMatrix = async () => {
        setRoleMatrixLoading(true);
        try {
            const blob = await roleService.downloadRoleMatrix();
            downloadFile(blob, t("roleMatrix"), "xls");
        } catch {
            toast.error(t("downloadError"));
        } finally {
            setRoleMatrixLoading(false);
        }
    }

    const onDownloadRoleTree = async () => {
        setRoleTreeLoading(true);
        try {
            const blob = await roleService.downloadRoleTree();
            downloadFile(blob, t("roleTree"), "xls");
        } catch {
            toast.error(t("downloadError"));
        } finally {
            setRoleTreeLoading(false);
        }
    }

    const onUploadRoleMatrix = async (file: File) => {
        setRoleMatrixUploading(true);
        roleService.uploadRoleMatrix(file.name, file).then((res) => {
            if (res === "OK") {
                toast.success(t("fileUploaded"));
            } else {
                toast.error(res);
            }
        }).finally(() => {
            setRoleMatrixUploading(false)
        })
    }

    const onUploadRoleTree = async (file: File) => {
        setRoleTreeUploading(true);
        roleService.uploadRoleTree(file.name, file).then((res) => {
            if (res === "OK") {
                toast.success(t("fileUploaded"));
            } else {
                toast.error(res);
            }
        }).finally(() => {
            setRoleTreeUploading(false)
        })
    }

    return <div className={styles.container}>
        <div className={styles.buttonBlock}>
            <Button
                view="legal"
                className={styles.button}
                disabled={roleMatrixLoading}
                onClick={onDownloadRoleMatrix}>
                <div className={styles.buttonInnerContainer}>
                    <div>{t("downloadRoleMatrix")}</div>
                    {roleMatrixLoading && <CircularProgress size={15} className={styles.loader}/>}
                </div>
            </Button>
            <SingleFileUpload className={styles.button}
                              view="legal"
                              accept=".xls"
                              loading={roleMatrixUploading}
                              text={t("uploadRoleMatrix")}
                              onFileChange={onUploadRoleMatrix}/>
        </div>
        <div className={styles.buttonBlock}>
            <Button
                view="legal"
                className={styles.button}
                disabled={roleTreeLoading}
                onClick={onDownloadRoleTree}>
                <div className={styles.buttonInnerContainer}>
                    <div>{t("downloadRoleTree")}</div>
                    {roleTreeLoading && <CircularProgress size={15} className={styles.loader}/>}
                </div>
            </Button>
            <SingleFileUpload className={styles.button}
                              view="legal"
                              loading={roleTreeUploading}
                              accept=".xls"
                              text={t("uploadRoleTree")}
                              onFileChange={onUploadRoleTree}/>
        </div>
    </div>
});
